module.exports = __webpack_public_path__ + "static/media/file-user.e118e5da.svg";